import { CircleWrapper, PictogramIconWrapper, getColor } from './style';
import { type PictogramCircleProps } from './Pictograms/types';
import { BackgroundCircle } from './Pictograms';

export const PictogramCircle = ({
  pictogram,
  variant = 'grey',
  light = false,
  size = '110px',
  iconSize = '38.78%',
}: PictogramCircleProps) => {
  return (
    <CircleWrapper size={size} variant={variant}>
      <BackgroundCircle color={getColor(variant)} light={light} />
      <PictogramIconWrapper variant={variant} iconSize={iconSize}>
        {pictogram}
      </PictogramIconWrapper>
    </CircleWrapper>
  );
};
